/**
 *  Pobiera statystyki generowanie przez backend
*/

import { GET_BSTATS } from '../types';

import api from '../../api';

export const getBackendStats = () => async dispatch => {

  const options = {
    method: 'get',
    url: '/course/time/overall',
    withCredentials: true
  }

  let response = {};
  try {
    response = await api(options);
  } catch (e) {}

  if (response.status === 200) {
    dispatch({ type: GET_BSTATS, stats: response.data });
  }
}